import { GetterTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { ProcedureState } from './ProcedureState'
import { ProcedureDto } from '@/Application/Procedures'
import { BatchDto } from '@/Application/Batch'
import { BatchDtoJson } from '@/Application/Batch/BatchDtoJson'

const parseBatchesJsonObject: (jsonObjects: BatchDtoJson[]) => BatchDto[] = (jsonObjects) => {
  return jsonObjects.map(current => BatchDto.fromJSON(current))
}

export const getters: GetterTree<ProcedureState, RootState> = {
  currentProcedureId (state: ProcedureState): string {
    return state.currentProcedure === undefined ? '' : state.currentProcedure.procedureId
  },
  currentProcedureType (state: ProcedureState): string {
    return state.currentProcedure === undefined ? '' : state.currentProcedure.procedureType
  },
  currentProcedure (state: ProcedureState): ProcedureDto | undefined {
    if (state.currentProcedure === undefined) {
      return undefined
    }
    if (state.currentProcedure instanceof ProcedureDto === false) {
      return ProcedureDto.fromJSON(state.currentProcedure)
    }
    return state.currentProcedure
  },
  resultasBatches (state: ProcedureState): BatchDto[] {
    if (state.resultasBatches[0] instanceof BatchDto === false) {
      return parseBatchesJsonObject(state.resultasBatches)
    }

    return state.resultasBatches
  },
  riscoBatches (state: ProcedureState): BatchDto[] {
    if (state.riscoBatches[0] instanceof BatchDto === false) {
      return parseBatchesJsonObject(state.riscoBatches)
    }
    return state.riscoBatches
  }
}
